<div class="grid">
    <div class="col-12">
        <div class="card" *ngIf="!verificarPermissao('PERM_LISTAR_CENTRAL_CLIENTE')">
            <div style="text-align: center;">
                <h4>Você não possui permissão de acesso essa página!</h4>
            </div>
        </div>
        <div class="card" *ngIf="verificarPermissao('PERM_LISTAR_CENTRAL_CLIENTE')">


            <div class="flex justify-content-center" *ngIf="exibirSpinnerPrincipal">
                <p-progressSpinner></p-progressSpinner>
            </div>
            <div *ngIf="messagemVisivel" class="w-full mb-5">
                <p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
            </div>
            <div class="w-full" *ngIf="!exibirSpinnerPrincipal">
                <p-table #tbPacotes [value]="contasClientes" dataKey="id" [rows]="10" [rowHover]="true" [loading]="loading"
                    [paginator]="true" (onLazyLoad)="onLazyLoad($event)" [lazy]="true" [rows]="itensPaginados ? itensPaginados.size : 0"
                    [totalRecords]="itensPaginados ? itensPaginados.totalElements : 0" [showCurrentPageReport]="true"
                     [globalFilterFields]="['descricao']" responsiveLayout="stack" styleClass=" p-datatable-sm"
                    currentPageReportTemplate="Mostrando {first} ao {last} de {totalRecords} registros">
                    <ng-template pTemplate="caption">
                        <div class="flex justify-content-end flex-column sm:flex-row">
                            <div class="p-fluid mt-2 sm:mt-4">
                                <div class="flex">
                                    <span class="p-input-icon-left">
                                        <i class="pi pi-search"></i>
                                        <input pInputText type="text" #filter (input)="buscar($event)"
                                            placeholder="Buscar" class="w-full" />
                                    </span>
                                    <span class="ml-2">
                                        <button pButton class="p-button-outlined" icon="pi pi-filter-slash"
                                            pTooltip="Limpar Filtros" (click)="limpar()"></button>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="header">
                        <tr>
                            <th pSortableColumn="nomeCliente">
                                Nome
                                <p-sortIcon field="nomeCliente">
                                </p-sortIcon>
                            </th>
                            <th pSortableColumn="saldoCliente">
                                Saldo
                                <p-sortIcon ield="saldoCliente">
                                </p-sortIcon>
                            </th>
                            <th>
                                Ações
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-item>
                        <tr>
                            <td>
                                {{item.nomeCliente}}
                            </td>
                            <td *ngIf="item.saldoCliente < 0" class="text-red-500">
                                {{item.saldoCliente | currency:'BRL' }}
                            </td>
                            <td *ngIf="item.saldoCliente >= 0">
                                {{item.saldoCliente | currency:'BRL' }}
                            </td>
                            <td>
                                <button class="p-button-info" pButton pRipple icon="pi pi-eye" pTooltip="Detalhar"
                                    routerLink="/apps/central-cliente/conta/detalhar/{{item.clienteId}}">
                                </button>
                            </td>

                        </tr>
                    </ng-template>
                    <ng-template pTemplate="summary">
                        <div class="flex align-items-center justify-content-between">
                            
                        </div>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="7">Nenhum registro encontrado.</td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="loadingbody">
                        <tr>
                            <td colspan="7">Carregando. Por favor aguarde.</td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>

            <div class="formgroup" *ngIf="!exibirSpinnerPrincipal">
                <div class="p-fluid p-formgrid grid justify-content-end">
                    <div class="col-12 md:col-4 flex justify-content-end">
                        <button type="button" pButton class="p-button-outlined sm:w-9rem mt-5" icon="pi pi-arrow-left"
                            label="Voltar" routerLink="/apps/central-cliente">
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>